import Component from 'core/Component';
import { deepMerge } from 'toolbox/deepMerge';
import { ajax } from 'toolbox/ajax';
import { Event } from 'services/EventEmitter';

/**
 * This is a description of the Optanon constructor function.
 * @class
 * @classdesc This is a description of the Optanon class. (must be edited)
 * @extends Component
 */
export default class Optanon extends Component {
    /**
     * Constructor of the class that mainly merge the options of the components
     * @param {HTMLElement} element HTMLElement of the component
     * @param {Object} options options that belongs to the component
     */
    constructor(element, options = {}) {
        super(element, deepMerge({
            changeSessionTrackingUrl: '',
            cookies: {
                optanon: 'OptanonConsent',
                dw: 'dw_dnt',
            },
            buttons: {
                confirmMyChoices: 'Confirm My Choices',
                allowAll: 'Allow All',
            },
            id: {
                saveButton: 'save-btn',
                saveContainer: 'save-container',
                acceptContainer: 'accept-container',
                acceptRecommended: 'accept-recommended-btn-handler',
                acceptRecommendedContainer: 'accept-recommended-container',
            },
        }, options));
    }

    /**
     * Should contain only event listeners and nothing else
     * All the event handlers should be into a separated function. No usage of anonyous function
     */
    bindEvents() {
        window.OptanonWrapper = this.optanonWrapperEvent.bind(this);
        window.addEventListener('load', this.optanonDisplayPopup.bind(this));
    }

    /**
     * Optanon Wrapper window Event.
     * https://community.cookiepro.com/s/article/UUID-730ad441-6c4d-7877-7f85-36f1e801e8ca
     * As can be seen in the linked documentation, this code, which is assigned to window.OptanonWrapper, is executed:
     * - on every page load
     * - each time preferences are saved, if a change from active to inactive has been made
     * What the code does here is sending an ajax request to a dedicated endpoint (not cached) that will then act
     * depending on the state of the different consents.
     * It's necessary to do that on each page load because, as the doc says, there isn't any event
     * to handle the removal of a given consent.
     * This means that if we want to stay compliant by properly removing custom 1st party cookies upon consent removal,
     * we need to check the consent state on each request.
     * @return {*} ajax response
     */
    optanonWrapperEvent() {
        const url = `${this.options.changeSessionTrackingUrl}`;
        return ajax(url)
            .then(() => {
                Event.emit('Onetrust.activegroups.updated');
            })
            .catch(() => {});
    }

    /**
     * Optanon cookie policy popup - onetrust v2
     */
    optanonDisplayPopup() {
        if ((typeof window.Optanon === 'undefined') || !this.options.optanonDomainScriptID) {
            return;
        }

        if (this.options.optanonCookieToggleInfoDisplayEnable && ('IsAlertBoxClosed' in window.Optanon) && (window.Optanon.IsAlertBoxClosed() === false)) {
            window.Optanon.ToggleInfoDisplay();
        }

        if (document.getElementById(this.options.id.saveContainer) === null) {
            this.optanonAddBtns();
        }
    }

    /**
     * Add buttons to Optanon cookie policy popup - onetrust v2
     */
    optanonAddBtns() {
        const { confirmMyChoices, allowAll } = this.options.buttons;
        const saveButton = `<button id="${this.options.id.saveButton}" class="${this.options.classes.saveContainer}" style="${this.options.styles.confirmMyChoices}" aria-label="${confirmMyChoices}" role="button" tabindex="0">${confirmMyChoices}</button>`;
        const acceptButton = `<button id="${this.options.id.acceptRecommended}" class="${this.options.classes.buttonTheme}" style="${this.options.styles.allowAll}" aria-label="${allowAll}" role="button" tabindex="0">${allowAll}</button>`;

        const top = document.getElementById(this.options.id.acceptRecommendedContainer);
        const footer = document.getElementsByClassName(this.options.classes.savePreference)[0];

        const divSave = document.createElement('div');
        divSave.id = this.options.id.saveContainer;

        const divAccept = document.createElement('div');
        divAccept.id = this.options.id.acceptContainer;

        divSave.innerHTML = saveButton;
        divAccept.innerHTML = acceptButton;

        if (top) {
            top.appendChild(divSave);
        }

        if (footer) {
            footer.appendChild(divAccept);
        }
    }
}
